// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  PRECIO_JUSTO_ACT_CLEAN_BATCH_SEARCH_RESULT,
} from './constants';

export function actCleanBatchSearchResult() {
  return {
    type: PRECIO_JUSTO_ACT_CLEAN_BATCH_SEARCH_RESULT,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PRECIO_JUSTO_ACT_CLEAN_BATCH_SEARCH_RESULT:
      return {
        ...state,
        actBatchFindToCsvPending: false,
        actBatchSearchResultPending: false,
        actBatchSearchResultError: null,
        batchResults: null,
      };

    default:
      return state;
  }
}
